import {useCallback, useState} from 'react';

export default function useRenderId() {
  const [renderId, setRenderId] = useState('initial');

  const forceRerender = useCallback(() => setRenderId(Date.now().toString()), [setRenderId]);
  return [renderId, forceRerender];
}
